exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customerForm /deep/ form > div:nth-child(13) ::-webkit-input-placeholder{\r\n    color: #C7C7CD;\r\n}\r\n\r\n#customerForm /deep/ form > div:nth-child(14) ::-webkit-input-placeholder{\r\n    color: #C7C7CD;\r\n}\r\n\r\n#customerForm /deep/ form > div:nth-child(15) ::-webkit-input-placeholder{\r\n    color: #C7C7CD;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/admin/customer/customer.css
// module id = 977
// module chunks = 0